import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en/translation.json";
import cs from "./cs/translation.json";

const resources = { en: { translation: en }, cs: { translation: cs } };

const SUPPORTED_LANGS = Object.keys(resources);
const FALLBACK_LANG = "en";

i18n.use(initReactI18next).init({
  resources,
  lng: FALLBACK_LANG,
  fallbackLng: FALLBACK_LANG,
  interpolation: { escapeValue: false },
});

export async function detectAndSetLanguage(multilanguage: boolean) {
  try {
    const forceEnglish = localStorage.getItem("forceEnglish") === "1";
    if (forceEnglish) {
      i18n.changeLanguage("en");
      return "en";
    }

    if (!multilanguage) {
      i18n.changeLanguage("en");
      return "en";
    }

    const savedLang = localStorage.getItem("lang");
    if (savedLang && SUPPORTED_LANGS.includes(savedLang)) {
      i18n.changeLanguage(savedLang);
      return savedLang;
    }

    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();

    const country = data.country_code?.toLowerCase();
    const detected =
      country === "cz" || country === "sk" ? "cs" : FALLBACK_LANG;

    i18n.changeLanguage(detected);
    localStorage.setItem("lang", detected);
    console.debug(`[i18n] Detected language by IP: ${detected}`);

    return detected;
  } catch (err) {
    console.warn("[i18n] Language detection failed:", err);
    i18n.changeLanguage(FALLBACK_LANG);
    return FALLBACK_LANG;
  }
}

export default i18n;
